import styled from 'styled-components';

const CategoriesSelector = styled.div`
  width: 100%;
`;
const Section = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.COLOR_GREY2};
  &:last-child {
    border-bottom: none;
  }
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  height: 30px;
  width: 100%;
  & svg {
    margin-right: 10px;
  }
`;

const CategoryHeader = styled(Header)`
  margin: 10px 0;
`;

const HeaderItem = styled.span`
  display: flex;
  align-items: center;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 600;
`;

const HeaderTitle = styled.span`
  margin-left: 8px;
`;

const Img = styled.img`
  width: 24px;
  height: auto;
`;

const CategoryActionIcon = styled(HeaderItem)`
  color: ${({ theme }) => theme.COLOR_GREY3};
  font-size: 16px;
`;

const HeaderItemAction = styled(HeaderItem)`
  color: ${({ theme }) => theme.COLOR_GREY3};
  font-size: 14px;
  & svg {
    margin-left: 5px;
  }
`;

const Content = styled.div`
  padding: 0px;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 10px;
`;

const ButtonItem = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 128px;
  padding: 10px;
  border: 1px solid ${({ theme }) => theme.COLOR_GREY2};
  border-radius: 6px;
  cursor: pointer;
  margin: 5px 5px 5px 0px;
  background: ${({ isSelected, theme }) =>
    isSelected ? theme.COLOR_BLACK : theme.COLOR_WHITE};
  color: ${({ isSelected, theme }) =>
    isSelected ? theme.COLOR_WHITE : theme.COLOR_BLACK};
  font-size: 16px;
  font-weight: 500;
  @media (hover: hover) {
    &:hover {
      border: 1px solid ${({ theme }) => theme.COLOR_GRAY5};
      background-color: ${({ theme }) => theme.COLOR_BG_DARK};
      color: ${({ theme }) => theme.COLOR_BLACK};
    }
  }
`;
const OEMButton = styled(ButtonItem)``;

const ModelButton = styled(ButtonItem)``;
const CapacityButton = styled(ButtonItem)``;
const SpecButton = styled(ButtonItem)``;
const SelectedFilterItem = styled(ButtonItem)`
  justify-content: space-between;
  width: auto;
  padding: 3px 0;
  background: red;
  color: white;
  font-size: 12px;
  font-weight: 500;
  border: none;
  & svg {
    margin-right: 5px;
  }
`;

const FilterText = styled.span`
  padding: 0 8px 0 10px;
`;

const StyledCategoriesSelector = {
  CategoriesSelector,
  Section,
  Header,
  HeaderItem,
  HeaderItemAction,
  Content,
  OEMButton,
  ModelButton,
  CapacityButton,
  SpecButton,
  SelectedFilterItem,
  FilterText,
  Img,
  HeaderTitle,
  CategoryActionIcon,
  CategoryHeader,
};

export default StyledCategoriesSelector;
